import paper from 'paper';

class DrawManager {
  _drawIntervalId: any;
  _currentPath: any;
  _referencePoint: any;
  drawnPaths: any[];
  strokeWidth: any;
  constructor(strokeWidth) {
    this._drawIntervalId = null;
    this._currentPath = null;
    this._referencePoint = null;
    this.drawnPaths = [];
    this.strokeWidth = strokeWidth;
  }

  isReversed(guidelineSVG) {
    return guidelineSVG ? guidelineSVG.name.match(/reversed/) : null;
  }

  drawReferencePoint(guidelineSVG, strokeWidth = 10) {
    const length = guidelineSVG ? guidelineSVG.data.coordinates.length - 1 : 0;
    const index = this.isReversed(guidelineSVG) ? length : 0;

    if (guidelineSVG) {
      this._referencePoint = new paper.Path.Circle({
        center: [
          guidelineSVG.data.coordinates[index].x,
          guidelineSVG.data.coordinates[index].y,
        ],
        radius: strokeWidth,
        fillColor: 'black',
      });
    }
  }

  drawDot(guidelineSVG, strokeWidth = 10) {
    const { x, y } = guidelineSVG.data;

    this.drawnPaths.push(
      new paper.Path.Circle({
        center: [x, y],
        radius: strokeWidth,
        fillColor: 'black',
      })
    );
  }

  drawPath(guidelineSVG, drawTime = 1, strokeWidth = 15) {
    const length = guidelineSVG.data.coordinates.length - 1;
    const timeInterval = (drawTime * 1000) / length;
    let index = this.isReversed(guidelineSVG) ? length : 0;
    let x = 0;
    let y = 0;

    this._referencePoint.remove();

    this._currentPath = new paper.Path({
      strokeCap: 'round',
      strokeColor: 'black',
      strokeWidth: strokeWidth,
    });

    return new Promise((resolve: any) => {
      this._drawIntervalId = setInterval(() => {
        if (this.isReversed(guidelineSVG)) {
          if (index >= 0) {
            ({ x, y } = guidelineSVG.data.coordinates[index]);
            this.drawPoint(x, y);
            index--;
          } else {
            this.drawnPaths.push(this._currentPath);
            clearInterval(this._drawIntervalId);
            resolve();
          }
        } else {
          if (index <= length) {
            ({ x, y } = guidelineSVG.data.coordinates[index]);
            this.drawPoint(x, y);
            index++;
          } else {
            this.drawnPaths.push(this._currentPath);
            clearInterval(this._drawIntervalId);
            resolve();
          }
        }
      }, timeInterval);
    });
  }

  drawPoint(x, y) {
    this._currentPath.add(new paper.Point(x, y));
  }

  stopDrawing() {
    if (this._drawIntervalId) {
      clearInterval(this._drawIntervalId);
    }
  }

  removeAllDrawnPaths() {
    if (this._currentPath) {
      this._currentPath.remove();
    }
    this.drawnPaths.forEach((path) => {
      path.remove();
    });
    this.drawnPaths = [];
  }
}

export default DrawManager;
